import FormLogin from '../components/FormLogin';

const LoginPage = () => {
  return (
    <div className="overflow-y-hidden h-[600px] text-white bg-slate-950 rounded-full  flex flex-col items-center justify-center w-full">
      <FormLogin />
    </div>
  );
};

export default LoginPage;
